import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import {
  NoticeCreate1Cmd,
  NoticeCreate2Cmd,
  NoticeDeleteCmd
} from "@youm-front/notice/domain";
import { v4 as uuid } from "uuid";
import { NoticeActions } from "../actions";
import { NoticeSelectors } from "../selectors";

@Injectable()
export class NoticeFacade {
  notices$ = this.store.pipe(select(NoticeSelectors.notices));

  constructor(private readonly store: Store) {}

  noticeCreate(noticeCreateCmd: NoticeCreate1Cmd) {
    const { kind, data } = noticeCreateCmd.value;

    this.store.dispatch(
      NoticeActions.noticeCreate({
        noticeCreateCmd: new NoticeCreate2Cmd({
          id: uuid(),
          kind,
          data,
          createdAt: Date.now()
        })
      })
    );
  }

  noticeDelete(noticeDeleteCmd: NoticeDeleteCmd) {
    this.store.dispatch(NoticeActions.noticeDelete({ noticeDeleteCmd }));
  }
}
